import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { wrapFunctionalComponent } from 'utils/framework';
import { Text, Box, Link } from 'components/ui';
import CompareZoneBase from 'components/Catalog/ProductGrid/CompareModal/Zones/CompareZoneBase';
import { fontSizes, lineHeights } from 'style/config';

const IngredientContent = ({ sku, getText, showAll, toggleShowAll }) => {
    const textRef = useRef(null);

    const lineHeight = fontSizes['lg-bg'] * lineHeights['none']; // Calculate line height in pixels
    const maxLinesCollapsed = 7; // Show 7 lines when collapsed
    const maxHeight = lineHeight * maxLinesCollapsed;

    return (
        <Box baseCss={{ gap: 0 }}>
            <Box
                ref={textRef}
                overflow='hidden'
                maxHeight={showAll ? 'none' : `${maxHeight}px`}
            >
                <Text
                    fontSize='base'
                    textAlign={sku.ingredientDesc ? 'left' : 'center'}
                    lineHeight={`${fontSizes['lg-bg']}px`}
                    is='p'
                    dangerouslySetInnerHTML={{ __html: sku.ingredientDesc || '-' }}
                />
            </Box>
            {sku.ingredientDesc && (
                <Link
                    onClick={toggleShowAll}
                    color='blue'
                    fontSize='base'
                    css={{ cursor: 'pointer' }}
                >
                    {!showAll ? getText('showAll') : getText('showLess')}
                </Link>
            )}
        </Box>
    );
};

IngredientContent.propTypes = {
    sku: PropTypes.object.isRequired,
    getText: PropTypes.func.isRequired,
    showAll: PropTypes.bool.isRequired,
    toggleShowAll: PropTypes.func.isRequired
};

const IngredientsZone = ({ skus = [], getText = () => {} }) => {
    const [showAll, setShowAll] = useState(false);

    const toggleShowAll = () => {
        setShowAll(!showAll);
    };

    const renderContent = sku => {
        return (
            <IngredientContent
                sku={sku}
                getText={getText}
                showAll={showAll}
                toggleShowAll={toggleShowAll}
            />
        );
    };

    return (
        <CompareZoneBase
            skus={skus}
            getText={getText}
            titleKey='ingredients'
            renderContent={renderContent}
            isCollapsed={true}
        />
    );
};

IngredientsZone.propTypes = {
    skus: PropTypes.arrayOf(PropTypes.object),
    getText: PropTypes.func
};

export default wrapFunctionalComponent(IngredientsZone, 'IngredientsZone');
